import React, { Component } from 'react';

class OfferSummaryComponent extends Component {
	render() {
		return (
			<div className="offer-summary">
				<div className='card-mode'>
					<div className="row">
						{this.props.items.map((item, i) => {
							return (
								<div key={i} className='form-group col px-1'>
									<div className="card text-white mb-3" style={{border: 'none'}}>
										<div className="card-header" style={{background: '#fff', textAlign: 'center'}}>
											{/* <p style={{ marginBottom: '0.2rem'}}>{item.fai} </p> */}
											<h5 className='medium' style={item.contentStyle}>{item.name}</h5>
										</div>
										<div className="card-body medium" style={{ background: '#F6F8FF' }}>
											<h5 style={{ margin: 'auto 0', padding: '0.5em 0' , textAlign: 'center', fontWeight: '700' }}>{item.content}</h5>
										</div>
									</div>
								</div>
							)
						})}
					</div>
				</div>
				<div className="table-mode mb-3 shadowBox" >
					<table className='table mb-0' >
						{this.props.items.map((item, i) => {
							return (
								<tr key={i} className="">
									<td className='pb-1 ' style={{fontSize: '1rem', fontWeight: '400', color: "#000000", border: "none" }}>{item.name}</td>
									<td className='pb-1' style={{fontSize: '1rem', fontWeight: '700', color: "#000000", border: "none" }}><strong>{item.content}</strong></td>
								</tr>
							)
						})}
					</table>
				</div>
			</div>

		);
	}
}

//PropTypes
OfferSummaryComponent.propTypes = {
}

export default OfferSummaryComponent;
